import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionContactCenter";
import { PostComisionContactCenterCalcular } from "../../../reducers/comisionContactCenter";

export interface GeneracionContactCenterDispatcher {
  postCalcularComisiones: (
    formData: FormData,
    periodo: string,
    confirmar: boolean
  ) => Promise<Preview<PostComisionContactCenterCalcular>>;
}

export const generacionContactCenterDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => GeneracionContactCenterDispatcher = dispatch => ({
  postCalcularComisiones: (
    formData: FormData,
    periodo: string,
    confirmar: boolean
  ) => {
    return dispatch(
      actions.postCalcularComisiones(formData, periodo, confirmar)
    );
  }
});
